import { Link } from "react-scroll";
import { Code2, Heart, Download, Sparkles } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="border-t border-b border-[#dfdfdf]">
      <div className="container mx-auto flex flex-col md:flex-row items-stretch min-h-[70vh]">
        <div className="py-12 h-full flex items-center px-6">
          <h1 className="text-[9vw] md:text-7xl text-[#DFDFDF] uppercase leading-5 font-extrabold">
            About Me.
          </h1>
        </div>
        <div className="py-12 px-3 md:px-10 flex-1 flex flex-col justify-center border-t md:border-t-0 md:border-l border-[#dfdfdf]">
          <div className="space-y-6 text-lg text-gray-300 leading-relaxed">
            <p className="flex items-start space-x-3">
              <Code2 className="text-blue-400 mt-1 flex-shrink-0" size={20} />
              <span>
                I specialize in developing{" "}
                <span className="text-white font-semibold">
                  visual and user-friendly
                </span>{" "}
                web applications and websites. I enjoy transforming complex
                ideas into simple solutions that solve real-world problems.
              </span>
            </p>

            <p className="flex items-start space-x-3">
              <Heart className="text-red-400 mt-1 flex-shrink-0" size={20} />
              <span>
                Helping people get things done through technology gives me
                immense satisfaction. Coding is my way of making a positive
                impact, one application at a time.
              </span>
            </p>

            <p className="flex items-start space-x-3">
              <Sparkles
                className="text-yellow-400 mt-1 flex-shrink-0"
                size={20}
              />
              <span>
                When I'm not coding, I enjoy family time, I listen to music or
                watch a movie.
              </span>
            </p>
          </div>

          <br />

          <div className="flex flex-wrap gap-4">
            <Link
              to="contact-me"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="font-bold text-[#DFDFDF] flex items-center flex-row gap-3 hover:text-[#f34c08] leading-5"
            >
              Say Hi!{" "}
              <img
                src="https://static.tildacdn.net/tild3237-6234-4032-b235-366666373735/photo.svg"
                alt=""
                className="text-white w-6 h-6 animate-wiggle"
              />
            </Link>

            <a
              href="/images/JOSHUA_EJEMBI_RESUME.pdf"
              download={true}
              className="flex items-center space-x-2 border hover:border-[#f34c08] text-gray-300 hover:text-white px-6 py-3 rounded-lg font-medium transition-all duration-300 transform hover:scale-105 hover:bg-[#f34c08]"
            >
              <Download size={20} />
              <span>Download CV</span>
            </a>
          </div>
        </div>{" "}
      </div>
    </section>
  );
}
